import { render, staticRenderFns } from "./StackTest.vue?vue&type=template&id=81d548c2&"
import script from "./StackTest.vue?vue&type=script&lang=js&"
export * from "./StackTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports